(function () {
    'use strict';

    angular
        .module('app')
        .directive('stickyElement', stickyElement);

    stickyElement.$inject = ['$compile', '$window'];

    /**
     * Make an element "sticky", so once the window scrolls past the top of it, it stays fixed at the top of the window.
     *
     * This *could* be accomplished with CSS position:sticky, but support for this is limited as of time of writing.
     * http://caniuse.com/#feat=css-sticky
     * There's open-source directives, jQuery plugins, etc. all trying to do this, but support seems a bit sketchy,
     * so, we've written our own.
     */
    function stickyElement($compile, $window) {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        

        function link(scope, element, attrs) {
            if (!scope.isStickyChild) {

                // If there are other fixed elements above the sticky element, it needs an offset.
                // For now, that offset will always be 66, in future this might need to be configurable or dynamic.
                var topOffset = 66;

                var fixedElement = angular.element(element[0].cloneNode(true));

                var childScope = scope.$new();
                childScope.isStickyChild = true;
                $compile(fixedElement)(childScope);

                fixedElement.css('position', 'fixed');
                fixedElement.css('top', topOffset + 'px');
                fixedElement.css('visibility', 'hidden');
                fixedElement.css('z-index', '99');

                // Kill the scroll jank in Chrome / WebKit
                // https://benfrain.com/improving-css-performance-fixed-position-elements/
                fixedElement.css('backface-visibility', 'hidden');

                element[0].parentNode.appendChild(fixedElement[0]);

                // Find the first md-content element and use this for the scroll container.
                // If one is not found, use the window.
                var scrollContainer = angular.element(window.document).find('md-content');
                if (!_.isNil(scrollContainer) && scrollContainer.length > 0) {
                    scrollContainer = scrollContainer[0];
                } else {
                    scrollContainer = window;
                }

                angular.element($window).bind('resize', function () {
                    if (fixedElement.css('visibility') === 'visible') {
                        fixedElement.css('width', element[0].offsetParent.clientWidth);
                    }
                });

                scrollContainer.addEventListener('scroll', function (e) {
                    var clientRect = element[0].getBoundingClientRect();

                    // An element with a null offsetParent is not visible, e.g. in a not-selected tab.

                    if (clientRect.top <= topOffset && element[0].offsetParent !== null) {
                        if (fixedElement.css('visibility') !== 'visible') {
                            fixedElement.css('width', element[0].offsetParent.clientWidth);
                            fixedElement.css('visibility', 'visible');
                        }
                    } else {
                        if (fixedElement.css('visibility') !== 'hidden') {
                            fixedElement.css('visibility', 'hidden');
                        }
                    }
                });
            }
        }
    }
})();